module.exports = __webpack_public_path__ + "static/media/html-5.7334348a.svg";